import { Component } from '@angular/core';

@Component({
  selector: 'app-internal-server-error',
  standalone: false,
  styleUrls: ['./../error.scss'],
  template: `<div class="container-fluid">
  <div class="row">
      <div class="col">
          <div class="no-data">
            <div>
              <h1>Internal server error</h1>
              <span>Ohh! Something went bad, DMA service is temporarily unavailable. Please reach out to DMA team.</span>
              <a class="btn-brand primary d-inline-block mt-2" [routerLink]="['/']">Try Again</a>
            </div>
          </div>
      </div>
  </div>
</div>`
})
export class InternalServerErrorComponent  {
}
